<style>
    .image-upload>input {
        display: none;
    }

    a.right:link { text-decoration: none; color: white}
    a.right:active { text-decoration:blink}
    a.right:hover { text-decoration:underline; color: gold}
    a.right:visited {text-decoration: none; color: white}

    a.left:link { text-decoration: none; color: black}
    a.left:active { text-decoration:blink}
    a.left:hover { text-decoration:underline; color: gold}
    a.left:visited {text-decoration: none; color: black}

    .rightImageBubble {
        float: right;
        position: relative;
        display: inline-block;
        max-width: calc(70%);
        min-height: 18px;
        word-break: break-all;
        border-radius: 5px;
        border: 0 solid #000;
        margin-right: 20px;
    }
    .leftImageBubble {
        float: left;
        position: relative;
        display: inline-block;
        max-width: calc(70%);
        min-height: 18px;
        word-break: break-all;
        border-radius: 5px;
        border: 0 solid #000;
        margin-top: 3px;
        margin-left: 28px;
    }
    .rightBubble{
        float: right;
        position: relative;
        display: inline-block;
        max-width: calc(70%);
        min-height: 18px;
        line-height: 1.3;
        font-size: 13px;
        padding: 6px 6px;
        text-align: left;
        word-break: break-all;
        background-color: deeppink;
        color: #fff;
        border-radius: 5px;
        box-shadow: 0 1px 7px -5px #000;
        border: 0 solid #000;
        margin-right: 20px;
    }
    .rightBubble:after {
        content: "";
        border-top: solid 5px #00800000;
        border-left: solid 10px deeppink;
        border-right: solid 10px #00800000;
        border-bottom: solid 5px #00800000;
        position: absolute;
        top: 5px;
        left: 100%;
    }
    .leftBubble {
        float: left;
        display: inline-block;
        background-color: white;
        position: relative;
        max-width: calc(65%);
        min-height: 18px;
        line-height: 1.3;
        font-size: 13px;
        padding: 6px 6px;
        text-align: left;
        word-break: break-all;
        border-radius: 5px;
        color: #000;
        box-shadow: 0 1px 7px -5px #000;
        border: 0 solid #000;
        margin-top: 3px;
        margin-left: 30px;
    }
    .leftBubble:after {
        content: "";
        border-top: solid 5px #00800000;
        border-left: solid 10px #00800000;
        border-right: solid 10px white;
        border-bottom: solid 5px #00800000;
        position: absolute;
        top: 5px;
        right: 100%;
    }

</style>
<template>

    <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0">
        <!-- left div-->
        <div :style="'height: 100%; float: left; width: ' + (100 - this.chatViewWidth) + '%'">
            <div :style="'background: black; float: left; height: 100%; width: ' + this.otherVideoWidth +'%'">
                <div :style="'width: 100%; float: left; height:' + this.adminVideoHeight + 'px'">
                    <video ref="adminVideoView" autoplay="autoplay" muted="muted" style="object-fit: cover; float: left; height: 100%; width: 100%"/>
                    <el-avatar :src="this.adminCameraIcon" @click.native="openAdminCamera" style="cursor: pointer; position: absolute; margin-left: -65px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <el-avatar :src="this.adminMicrophoneIcon" @click.native="openAdminMicrophone" style="cursor: pointer; position: absolute; margin-left: -35px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                </div>
                <div style="width: 100%; height: 1px; float: left; background: slategray"/>
                <div :style="'width: 100%; float: left; height:' + this.operaVideoHeight + 'px'">
                    <video ref="operaVideoView" autoplay="autoplay" :muted="!isOperaAudioOpen" :style="'object-fit: contain; float: left; margin-top:' + this.operaVideoViewMarginTop + 'px; height: ' + this.operaVideoViewHeight + 'px; width: ' + this.operaVideoViewWidth + 'px; transform: rotate(' + this.operaVideoAngle + 'deg)'"/>
                    <el-avatar v-show="this.isOperaStreamPlay" :src="this.operaAudioIcon" @click.native="openOperaAudio" style="cursor: pointer; position: absolute; margin-left: -35px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <el-avatar v-show="this.isOperaStreamPlay" :src="this.rotateIcon" @click.native="rotateOperaVideo" style="cursor: pointer; position: absolute; margin-left: -70px; margin-top: 5px; width: 30px; height: 30px; background: transparent"></el-avatar>
                    <div v-show="!this.isOperaStreamPlay" style="position: absolute; color: white; margin-top: 15px; margin-left: 10px;">手法-离线</div>
                </div>
                <div style="width: 100%; height: 1px; float: left; background: slategray"/>
                <div style="position: relative; float: left; background-color: #63a35c; margin-left: 8px; margin-top: 5px" align="left">
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white">房间号：{{ this.Global.roomId }}</span>
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white; margin-top: 30px">手法秘钥：{{ this.operaPassword }}</span>
                    <span style="position: absolute; width: 300px; font-size: 17px; color: white; margin-top: 60px">人数：{{ this.userList.length }}</span>
                </div>

            </div>

            <div ref="usView" style="background: black; float: left; height: 100%; width: 70%;">
                <div style="background: slategray; position: absolute; float: left; height: 100%; width: 1px;"/>
                <div v-show="!this.isUsStreamPlay" style="color: white; position: absolute; float: right; margin-top: 15px; margin-left: 10px;">超声-离线</div>
                <video ref="usVideoView" autoplay="autoplay" style="object-fit: contain; height: 100%; width: 100%; z-index: 1"/>
                <el-button v-show="this.isUsStreamPlay" icon="hs-icon-full-screen el-iconfont" @click="this.usVideoFullScreen" circle
                           :style="'width: 50px; height: 50px; background: transparent; position: absolute; z-index: 2; border-color: transparent; margin-left: ' + (this.chatViewWidth === 0 ? -80 : -50) + 'px'"/>
            </div>

            <div v-show="this.chatViewWidth === 0" @click="this.showChatView">
                <slot name="left">
                    <img style="cursor: pointer; width: 45px; height: 45px; background: transparent; position: absolute; top: 0; right: 0"
                         src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNjA3MzI3NzE1ODQxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijg1OCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0xMDIyLjEyMjY2NjYxIDEwMzAuODI2NjY2NjdsLTI5NC45MTItMjE4LjQ1MzMzMzM0IDAtNjAwLjc0NjY2NjY2IDI5NC45MTItMjE4LjQ1MzMzMzM0TDEwMjIuMTIyNjY2NjEgMTAzMC44MjY2NjY2N3oiIGZpbGw9IiMwRDNCNTYiIHAtaWQ9Ijg1OSI+PC9wYXRoPjxwYXRoIGQ9Ik05MDQuMTU3ODY2NjEgNDM1LjU0MTMzMzMzYzMuODIyOTMzMzIgMCA3LjA5OTczMzMzIDEuNjM4NCA5LjgzMDQgNC4zNjkwNjY2NyA1LjQ2MTMzMzMzIDUuNDYxMzMzMzMgNS40NjEzMzMzMyAxNC43NDU2IDAgMjAuNzUzMDY2NjdsLTQ5LjY5ODEzMzMzIDUxLjMzNjUzMzMzIDQ5LjY5ODEzMzMzIDUxLjMzNjUzMzMzYzUuNDYxMzMzMzMgNS40NjEzMzMzMyA1LjQ2MTMzMzMzIDE0Ljc0NTYgMCAyMC43NTMwNjY2Ny01LjQ2MTMzMzMzIDUuNDYxMzMzMzMtMTQuMTk5NDY2NjcgNS40NjEzMzMzMy0xOS42NjA4IDBsLTU5LjUyODUzMzMzLTYxLjcxMzA2NjY3Yy0yLjczMDY2NjY3LTIuNzMwNjY2NjctNC4zNjkwNjY2Ny02LjU1MzYtNC4zNjkwNjY2Ny0xMC4zNzY1MzMzM3MxLjYzODQtNy42NDU4NjY2NyA0LjM2OTA2NjY3LTEwLjM3NjUzMzMzbDU5LjUyODUzMzMzLTYxLjcxMzA2NjY3YzIuNzMwNjY2NjctMi43MzA2NjY2NyA2LjU1MzYtNC4zNjkwNjY2NyA5LjgzMDQtNC4zNjkwNjY2N3oiIGZpbGw9IiNGRkZGRkYiIHAtaWQ9Ijg2MCI+PC9wYXRoPjwvc3ZnPg=="/>
                </slot>
            </div>

        </div>
        <!-- chat div--> <!-- https://blog.csdn.net/qq_31967569/article/details/107159054 -->
        <div v-show="this.chatViewWidth > 0" :style="'background: #ffffff; height: 100%; float: left; width: ' + this.chatViewWidth + '%'">

            <div :style="'height: 40px; background: #ffffff; position: absolute; z-index: 5; top: 0; width: ' + this.chatViewWidth + '%'">
                <el-button @click="this.dismissChatView" icon="el-icon-minus" circle style="background: transparent; float: left; border-color: transparent;"></el-button>
                <el-button @click="this.showUserList" icon="el-icon-s-custom" circle style="background: transparent; float: right; border-color: transparent;"></el-button>
                <p style="margin-left: 40px; height: 40px; margin-top: 10px; font-size: 15px">消息</p>
            </div>

            <div ref="chatMid" :style="'background: #F5f5f5; overflow: auto; position: absolute; z-index: 10; top: 40px; bottom: 160px; width: ' + this.chatViewWidth + '%'">
                <!--        https://www.cnblogs.com/godpo/p/12009353.html-->
                <el-row>
                    <el-col>
                        <div style="height: 100%; width: 100%; margin-bottom: 15px;" ref="chatListView">
                            <div v-for="(item, index) in roomMessages" :key="index" style="padding-top: 20px">
                                <el-row v-if="item.id_name === 'myself' && item.msg_type === 1"> <!-- 类型为 text -->
                                    <el-col>
                                        <span class="rightBubble">{{ item.msg_content }}</span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.id_name === 'myself' && item.msg_type === 3"> <!-- 类型为 file -->
                                    <el-col v-if="isImageFile(item.msg_content)"> <!-- 类型为 image file -->
                                        <span class="rightImageBubble">
                                            <el-image :src="item.msg_content" style="border-radius: 5px" :preview-src-list="[item.msg_content]"/>
                                        </span>
                                    </el-col>
                                    <el-col v-else> <!-- 类型为 other file -->
                                        <span class="rightBubble">
                                            <div style="display: flex">
                                                <el-image :src="fileIcon" style="width: 30px; height: 35px;"/>
                                                <a class="right" style="margin-left: 5px; margin-top: 5px; white-space: pre-line" target="_blank" :href="item.msg_content">{{ '文件:\n' + item.msg_content.split("/")[item.msg_content.split("/").length - 1] }}</a>
                                            </div>
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.id_name === 'time_msg'"> <!-- 时间消息 -->
                                    <el-col>
                                        <span style="font-size: 10px;">{{ item.msg_content }}</span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.msg_category === 2"> <!-- 系统消息 -->
                                    <el-col>
                                        <span style="font-size: 10px; background-color: rgba(163,163,163,0.38); padding-left: 10px; padding-right: 10px; color: white; border-radius: 15px">{{ item.msg_content }}</span>
                                    </el-col>
                                </el-row>
                                <el-row v-if="item.id_name !== 'myself' && item.id_name !== 'time_msg' && item.msg_category !== 2"> <!-- 收到的其他人的消息 -->
                                    <el-col :span="1">
                                        <el-avatar v-if="item.nick_name.startsWith('admin_')" :src="adminAvatar" style="margin-left: 10px; width: 25px; height: 25px"></el-avatar>
                                        <el-avatar v-else src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" style="margin-left: 10px; width: 25px; height: 25px"></el-avatar>
                                    </el-col>
                                    <el-col :span="23">
                                        <div style="width: 100%; height: 100%">
                                            <div style="font-size: 9px; margin-left: 30px; margin-top: -3px" align="left">{{ item.nick_name.replace("admin_", "管理员_") }}</div>
                                            <span v-if="item.msg_type === 1" class="leftBubble">{{ item.msg_content }}</span>

                                            <el-col v-if="item.msg_type === 3 && isImageFile(item.msg_content)"> <!-- 类型为 image file -->
                                                <span class="leftImageBubble">
                                                    <el-image :src="item.msg_content" style="border-radius: 5px" :preview-src-list="[item.msg_content]"/>
                                                </span>
                                            </el-col>
                                            <el-col v-if="item.msg_type === 3 && isImageFile(item.msg_content) === false"> <!-- 类型为 other file -->
                                                <span class="leftBubble">
                                                    <div style="display: flex">
                                                        <el-image :src="fileIcon" style="width: 30px; height: 35px;"/>
                                                        <a class="left" style="margin-left: 5px; margin-top: 5px; white-space: pre-line" target="_blank" :href="item.msg_content">{{ '文件:\n' + item.msg_content.split("/")[item.msg_content.split("/").length - 1] }}</a>
                                                    </div>
                                                </span>
                                            </el-col>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                               
            </div>
                       
            <div :style="'height: 160px; background: #ffffff; position: absolute; z-index: 6; bottom: 0; width: ' + this.chatViewWidth + '%'">                     
                <div style="margin-left: 10px; margin-right: 10px; height: 100%; position: relative;">
                    <div style="width: 100%; height: 40px;">
                        <div class="image-upload" style="height: 40px; width: 13%; position: absolute">
                            <label for="file-input" style="font-size: 20px">
                                <i class="el-icon-folder" style="margin-top: 10px"/>
                            </label>
                            <input ref="fileInput" id="file-input" type="file" @change="upload2OSS($event)"/>
                        </div>
                        <el-progress v-show="fileUploading" :percentage="uploadPercent" style="float: left; width: 85%; margin-left: 45px; margin-top: 12px"/>
                    </div>
                    <el-input ref="msgInput" type="textarea" :autosize="{minRows: 3, maxRows: 3}" placeholder="请输入内容" @keyup.native="msgInputKeyUp" :disabled="isSending" v-model="sendMessageContent" autofocus/>
                    <el-button type="primary" size="mini" style="float: right; margin-top: 5px; height: 33px; font-size: 13px" :loading="isSending" @click="sendMessage">发  送</el-button>
                </div>
            </div>

            <el-drawer :visible.sync="isShowUserList" :show-close="false" :with-header="false">
                <div style="height: 30px; margin-top: 10px">在线用户</div>
                <div style="height: 1px; background: #eeeeee"></div>
                <el-table :data="userList" :show-header="false">
                    <el-table-column fixed="left" width="40">
                        <template slot-scope="scope">
                            <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" style="width: 30px; height: 30px; border-radius: 15px"/>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="left">
                        <template slot-scope="scope">
                            <span v-if="scope.row.userName.startsWith('opera_')" style="float: left">手法端</span>
                            <span v-else-if="scope.row.userName.startsWith('us_')" style="float: left">超声端</span>
                            <span v-else-if="scope.row.userName.startsWith('admin_')" style="float: left">{{ scope.row.userName.replace("admin_", "管理员_") }}</span>
                            <span v-else style="float: left">{{ scope.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right">
                        <template slot-scope="scope">
                            <el-button v-show="!scope.row.userName.startsWith('admin_') && !scope.row.userName.startsWith('us_') && !scope.row.userName.startsWith('opera_')" style="float: right" size="mini" type="danger" @click="kickOut(scope.row)">踢出房间</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-drawer>

        </div>

    </div>
</template>

<script>

    import {Vue, Component} from 'vue-property-decorator';
    import md5 from 'js-md5';
    let Base64 = require('js-base64').Base64;

    export default {
        extends: Vue,
        data: function () {
            return {
                operaPassword: '',
                isSending: false, // 是否正在发送消息
                sendMessageContent: '', // 当前输入的消息内容
                roomMessages: [], // 房间消息列表
                adminAvatar: require("@/assets/admin_avatar.png"),
                adminMicrophoneIcon: require("@/assets/micphone_on.png"),
                adminCameraIcon: require("@/assets/camera_open.png"),
                operaAudioIcon: require("@/assets/audio_open.png"),
                rotateIcon: require("@/assets/rotate.png"),
                isAdminMicrophoneOpen: true,
                isAdminCameraOpen: true,
                isOperaAudioOpen: true,
                isOperaStreamPlay: false, // 手法流是否已播放
                isUsStreamPlay: false, // 超声流是否播放
                isSystemGoBack: false, // 是否是系统回退
                microphoneId: '', // 麦克风设备ID
                cameraId: '', // 摄像头设备ID
                isShowUserList: false, // 是否显示在线列表
                adminPublishingStreamId: 'admin_' + new Date().getTime(),
                leaveNext: null,
                roomHeartbeatTimer: null,
                fileUploading: false, // 正在上传文件
                uploadPercent: 0, // 上传进度
                fileIcon: require("@/assets/icon_file.png"),
                adminPublishConfig: {
                    "audio": this.microphoneId !== '',
                    "video": this.cameraId !== '',
                    "videoQuality": 2,
                    "horizontal": true,
                },
                userList: [], // 用户列表
                chatViewWidth: 25,
                otherVideoWidth: 30,
                adminVideoHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                operaVideoHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                operaVideoAngle: 0,
                operaVideoViewMarginTop: 0,
                operaVideoViewHeight: window.innerWidth * (30 / 100.0) * 108.0 / 192.0,
                operaVideoViewWidth: window.innerWidth * (1.0 - (25.0 / 100.0)) * (30.0 / 100.0) // window.innerWidth * (1.0 - (chatViewWidth / 100.0)) * (that.otherVideoWidth / 100.0)
            };
        },
        beforeDestroy: function() {
            clearInterval(this.roomHeartbeatTimer);
        },
        beforeRouteLeave: function (to, from, next) {
            let that = this;
            if (this.isSystemGoBack) {
                next();
            } else {
                this.$confirm('你确定要关闭房间吗?', '关闭房间', {
                    confirmButtonText: '确  定',
                    cancelButtonText: '取  消'
                }).then(() => {
                    that.operaStreamPlayStop();
                    that.usStreamPlayStop();
                    that.sendSystemMessage(that.Global.DestoryRoomMessage, false);
                    that.roomLogout();
                    that.Global.Zego.stopPreview(that.$refs.adminVideoView);
                    that.Global.Zego.stopPublishingStream(that.adminPublishingStreamId);
                    // 退出房间,释放资源
                    setTimeout(() => {
                        // 退出房间,释放资源
                        that.Global.Zego.logout();
                        next();
                    }, 300);
                }).catch(() => {
                    // 如果取消跳转地址栏会变化，这时保持地址栏不变
                    window.history.go(1);
                });
            }
        },
        mounted: function () {
            this.addZegoCallback();
            this.adminStreamPublish();
            this.usStreamPlay();
            this.operaStreamPlay();
            this.scrollChat2Bottom();
            this.operaPassword = this.obtainOperaKey();
            let that = this;
            window.onresize = function () {
                that.adminVideoHeight = window.innerWidth * (that.otherVideoWidth / 100.0) * 108.0 / 192.0;
                that.operaVideoHeight = window.innerWidth * (that.otherVideoWidth / 100.0) * 108.0 / 192.0;
                that.operaVideoViewHeight = that.operaVideoHeight;
                that.operaVideoViewWidth = window.innerWidth * (1.0 - (that.chatViewWidth / 100.0)) * (that.otherVideoWidth / 100.0);
            };
            // 开启房间心跳
            this.roomHeartbeatTimer = setInterval(this.roomHeartbeat, 10000);
        },
        methods: {
            /*
            * 上传文件到oss
            * */
            upload2OSS: function(event) {
                let that = this;
                if (this.$refs.fileInput.files.length > 0) {
                    let file = this.$refs.fileInput.files[0];
                    this.fileUploading = true;
                    this.uploadPercent = 0;
                    this.Global.OssClient.multipartUpload('chat/' + file.name, file, {
                        progress: function (percentage, cpt) {
                            that.uploadPercent = percentage * 100;
                        }
                    }).then(result => {
                        that.fileUploading = false;
                        let url = 'https://' + result.bucket + '.oss-cn-chengdu.aliyuncs.com/' + result.name;
                        that.sendFileMessage(url);
                    }).catch(err => {
                        that.fileUploading = false;
                        that.$message.info("图片发送失败错误，请重试！");
                    });
                }
            },
            /*
            * 发送文件消息
            * */
            sendFileMessage: function(url) {

                let that = this; // 闭包中无法使用this
                // msg_type: 3 文件类型
                this.Global.Zego.sendRoomMsg(1, 3, url, function (seq, msgId, msg_category, msg_type, msg_content) {
                    let message = {
                        id_name: 'myself',
                        nick_name: that.Global.ZegoConfig.nickName,
                        msg_content: msg_content,
                        send_time: new Date().getTime(),
                        msg_type: msg_type,
                        msg_category: msg_category,
                        msg_id: msgId
                    };
                    that.Global.ZegoSeq = seq;
                    that.insertTimeMessage();
                    that.roomMessages.push(message);
                    that.scrollChat2Bottom();
                }, function (err, seq, msg_category, msg_type, msg_content) {
                    that.$message.error("发送失败: " + err);
                    that.isSending = false;
                });
            },
            isImageFile: function(url) {
                return url.toLowerCase().endsWith('.jpg') || url.toLowerCase().endsWith('.jpeg') || url.toLowerCase().endsWith('.png') || url.toLowerCase().endsWith('.gif') || url.toLowerCase().endsWith('.bmp');
            },
            /*
            * 开关管理员端的麦克风
            * */
            openAdminMicrophone: function() {
                this.isAdminMicrophoneOpen = !this.isAdminMicrophoneOpen;
                this.adminMicrophoneIcon = this.isAdminMicrophoneOpen ? require("@/assets/micphone_on.png") : require("@/assets/micphone_off.png");
                let res = this.Global.Zego.enableMicrophone(this.$refs.adminVideoView, this.isAdminMicrophoneOpen);
                if (!res) {
                    this.$message.info("切换失败！");
                    this.isAdminMicrophoneOpen = !this.isAdminMicrophoneOpen;
                    this.adminMicrophoneIcon = this.isAdminMicrophoneOpen ? require("@/assets/micphone_on.png") : require("@/assets/micphone_off.png");
                }
            },
            /*
            * 开关管理员端的摄像头
            * */
            openAdminCamera: function() {
                this.isAdminCameraOpen = !this.isAdminCameraOpen;
                this.adminCameraIcon = this.isAdminCameraOpen ? require("@/assets/camera_open.png") : require("@/assets/camera_close.png");
                let res = this.Global.Zego.enableCamera(this.$refs.adminVideoView, this.isAdminCameraOpen);
                if (!res) {
                    this.$message.info("切换失败！");
                    this.isAdminCameraOpen = !this.isAdminCameraOpen;
                    this.adminCameraIcon = this.isAdminCameraOpen ? require("@/assets/camera_open.png") : require("@/assets/camera_close.png");
                }
            },
            /*
            * 开关手法端的声音
            * */
            openOperaAudio: function() {
                if (this.Global.operaStreamID.length < 3) {
                    return;
                }
                this.isOperaAudioOpen = !this.isOperaAudioOpen;
                this.operaAudioIcon = this.isOperaAudioOpen ? require("@/assets/audio_open.png") : require("@/assets/audio_close.png");
            },
            rotateOperaVideo: function() {
                if (this.operaVideoAngle % 180 === 0) {
                    this.operaVideoViewMarginTop = -(this.operaVideoViewWidth - this.operaVideoViewHeight) / 2.0;
                    this.operaVideoViewHeight = this.operaVideoViewWidth;
                } else {
                    this.operaVideoViewMarginTop = 0;
                    this.operaVideoViewHeight = this.operaVideoHeight;
                }
                this.operaVideoAngle = this.operaVideoAngle + 90;
            },
            /*
            * 滑动聊天消息栏到底部
            * */
            scrollChat2Bottom: function() {
                this.$nextTick(() => {
                    const chatListView = document.getElementById('chatMid');
                    chatListView.scrollTop = chatListView.scrollHeight;
                });
            },
            /*
            * 踢出房间
            * */
            kickOut: function(row) {
                let that = this;
                this.$confirm('你确定要将 ' + row.userName + ' 踢出房间吗?', '踢出房间', {
                    confirmButtonText: '确  定',
                    cancelButtonText: '取  消'
                }).then(() => {
                    that.Global.Zego.sendCustomCommand([row.userId], 'us_kick_out', (seq, customContent) => {
                        that.userList.splice(that.userList.findIndex(item => {
                            return item.userId === row.userId;
                        }), 1);
                        that.sendSystemMessage(row.userName + " 被踢出房间", true);
                    }, (err, seq, customContent) => {
                        that.$message.info(row.userName + " 踢出失败！");
                    });
                }).catch(() => {
                });
            },
            /*
            * 监听聊天输入框的键盘事件
            * */
            msgInputKeyUp: function(e) {
                if (e.shiftKey === true && e.keyCode === 13) { // shift + Enter
                    this.$message.info("shift + Enter");
                } else if (e.keyCode === 13) { // Enter
                    this.sendMessage();
                }
            },

            /*
            * 发送消息
            * */
            sendMessage: function() {
                if (this.sendMessageContent.trim().length === 0) {
                    this.$message.warning("发送消息不能为空！");
                    this.sendMessageContent = '';
                    this.$refs.msgInput.focus();
                    return;
                }
                this.isSending = true;
                let that = this; // 闭包中无法使用this
                // public static final int Text = 1;
                // public static final int Picture = 2;
                // public static final int File = 3;

                // public static final int Chat = 1;
                // public static final int System = 2;

                this.Global.Zego.sendRoomMsg(1, 1, this.sendMessageContent, function (seq, msgId, msg_category, msg_type, msg_content) {
                    let message = {
                        id_name: 'myself',
                        nick_name: that.Global.ZegoConfig.nickName,
                        msg_content: msg_content,
                        send_time: new Date().getTime(),
                        msg_type: msg_type,
                        msg_category: msg_category,
                        msg_id: msgId
                    };
                    that.Global.ZegoSeq = seq;
                    that.insertTimeMessage();
                    that.roomMessages.push(message);
                    that.sendMessageContent = '';
                    that.scrollChat2Bottom();
                    that.isSending = false;
                    that.$nextTick(() => {
                        that.$refs.msgInput.focus();
                    });
                }, function (err, seq, msg_category, msg_type, msg_content) {
                    that.$message.error("发送失败: " + err);
                    that.isSending = false;
                });
            },
            /*
             * 发送系统消息
              * */
            sendSystemMessage: function(textContent, showInChat) {
                if (textContent.length === 0) {
                    this.$message.warning("发送消息不能为空！");
                    return;
                }
                let that = this; // 闭包中无法使用this
                this.Global.Zego.sendRoomMsg(2, 1, textContent, function (seq, msgId, msg_category, msg_type, msg_content) {
                    if (showInChat) {
                        let message = {
                            id_name: 'sys_msg',
                            nick_name: that.Global.ZegoConfig.nickName,
                            msg_content: msg_content,
                            send_time: new Date().getTime(),
                            msg_type: msg_type,
                            msg_category: msg_category,
                            msg_id: msgId
                        };
                        that.Global.ZegoSeq = seq;
                        that.insertTimeMessage();
                        that.roomMessages.push(message);
                        that.scrollChat2Bottom();
                    }
                }, function (err, seq, msg_category, msg_type, msg_content) {
                    // that.$message.error("发送失败: " + err);
                });
            },

            /*
            * 超声画面全屏展示
            * */
            usVideoFullScreen: function () {
                this.$refs.usVideoView.requestFullscreen();
            },

            adminStreamPublish: function () {
                let that = this;
                this.Global.Zego.enumDevices(deviceInfo => {
                    if (deviceInfo.microphones) {
                        that.microphoneId = deviceInfo.microphones[0].deviceId;
                    }
                    if (deviceInfo.cameras) {
                        that.cameraId = deviceInfo.cameras[0].deviceId; // d09633b39f2ac77db765f4dde41093babda99caaa4b5babc1e641dcfce4d0546
                    }
                    that.Global.Zego.startPreview(that.$refs.adminVideoView, that.adminPublishConfig, () => {
                        that.Global.Zego.startPublishingStream(that.adminPublishingStreamId, that.$refs.adminVideoView);
                    }, err => {
                        that.$message.info("推流失败:" + err);
                    });
                }, err => {
                    that.$message.info("获取推流设备失败！");
                });
            },
            usStreamPlay: function () {
                if (this.Global.usStreamID.length > 3) {
                    this.isUsStreamPlay = this.Global.Zego.startPlayingStream(this.Global.usStreamID, this.$refs.usVideoView);
                    if (this.Global.isUSLandscape) {
                        this.chatViewWidth = 0;
                    } else {
                        this.chatViewWidth = 25;
                    }
                    this.operaVideoViewWidth = window.innerWidth * (1.0 - (this.chatViewWidth / 100.0)) * (this.otherVideoWidth / 100.0);
                }
            },

            usStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.usStreamID);
                this.Global.usStreamID = '';
                this.isUsStreamPlay = false;
            },

            operaStreamPlay: function () {
                if (this.Global.operaStreamID.length > 3) {
                    this.Global.Zego.startPlayingStream(this.Global.operaStreamID, this.$refs.operaVideoView);
                }
            },

            operaStreamPlayStop: function () {
                this.Global.Zego.stopPlayingStream(this.Global.operaStreamID);
                this.Global.operaStreamID = '';
                this.isOperaStreamPlay = false;
            },

            showUserList: function () {
                this.isShowUserList = !this.isShowUserList;
            },

            dismissChatView: function() {
                this.chatViewWidth = 0;
                this.adminVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoViewHeight = this.operaVideoHeight;
            },

            showChatView: function() {
                this.chatViewWidth = 25;
                this.adminVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoHeight = window.innerWidth * (this.otherVideoWidth / 100.0) * 108.0 / 192.0;
                this.operaVideoViewHeight = this.operaVideoHeight;
            },

            /*
            * 计算手法秘钥
            * */
            obtainOperaKey: function() {
                let md5Str = md5(this.Global.roomId);
                md5Str = md5(md5Str);
                let res = 0;
                for (let i = 0; i < md5Str.length; i++) {
                    res += md5Str.charCodeAt(i);
                }
                return '' + Math.abs(res * md5Str.charCodeAt(5) - Number(this.Global.roomId));
            },

            // 插入时间消息
            insertTimeMessage: function() {
                let isNeedInsert = false;
                if (this.roomMessages.length === 0) {
                    isNeedInsert = true;
                } else if (this.roomMessages.length > 0) {
                    let lastMsg = this.roomMessages[this.roomMessages.length - 1];
                    let lastMsgTime = lastMsg.send_time;
                    let currTime = new Date().getTime();
                    if (currTime - lastMsgTime > 5 * 60 * 1000) {
                        isNeedInsert = true;
                    }
                }
                if (isNeedInsert) {
                    let time = new Date();
                    let hour = time.getHours();
                    let min = time.getMinutes();
                    let sec = time.getSeconds();
                    let timeMessage = {
                        id_name: 'time_msg',
                        nick_name: 'Time',
                        msg_content: (hour < 10 ? "0" + hour : hour) + ":" + (min < 10 ? "0" + min : min) + ":" + (sec < 10 ? "0" + sec : sec),
                        send_time: new Date().getTime(),
                    };
                    this.roomMessages.push(timeMessage);
                }
            },

            userInUserList: function(userId) {
                let result = this.userList.find(item => {
                    return item.userId === userId;
                });
                return !(result === undefined);
            },
            // 房间心跳请求
            roomHeartbeat: function() {
                let data = new FormData();
                data.append("roomID", this.Global.roomId);
                data.append("requestKey", this.requestKey());
                fetch(this.Global.ServerUrl + '/user/updateRoom', {
                    method: 'POST',
                    body: data
                }).then(response => {
                }).catch(err => {
                });
            },
            // 结束房间
            roomLogout: function() {
                let data = new FormData();
                data.append("roomID", this.Global.roomId);
                data.append("requestKey", this.requestKey());
                fetch(this.Global.ServerUrl + '/user/logout', {
                    method: 'POST',
                    body: data
                }).then(response => {
                }).catch(err => {
                });
            },

            requestKey: function() {
                let timeString = '' + Math.round(new Date());
                timeString = timeString.substring(4, 8) + timeString.substring(8, 13) + timeString.substring(0, 4);
                let b64String = Base64.encode(timeString);
                b64String = b64String.replace("==\\n", "");
                b64String = b64String.substring(5, 12) + b64String.substring(12, 18) + b64String.substring(0, 5);
                b64String = Base64.encode(b64String);
                return b64String.replace("\\n", "");
            },

            addZegoCallback: function () {
                const that = this;

                // type Added = 0; Deleted = 1;
                this.Global.Zego.onStreamUpdated = function (type, streamList) {
                    if (streamList !== null && streamList.length > 0) {
                        streamList.forEach(item => {
                            const {stream_id, extra_info} = item;
                            if (type === 0) { // Added
                                if (stream_id.startsWith("opera_")) {
                                    if (that.Global.operaStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.operaStreamID);
                                    }
                                    that.Global.operaStreamID = stream_id;
                                    that.operaStreamPlay();
                                } else if (stream_id.startsWith("us_")) {
                                    if (that.Global.usStreamID.length > 3) {
                                        that.Global.Zego.stopPlayingStream(that.Global.usStreamID);
                                    }
                                    that.Global.usStreamID = stream_id;
                                    that.usStreamPlay();
                                    if (extra_info.indexOf("Landscape") !== -1) {
                                        that.chatViewWidth = 0;
                                    } else if (extra_info.indexOf("Portrait") !== -1) {
                                        that.chatViewWidth = 25;
                                    }
                                }
                            } else if (type === 1) { // Deleted
                                if (stream_id.startsWith("opera_")) {
                                    that.operaStreamPlayStop();
                                } else if (stream_id.startsWith("us_")) {
                                    that.usStreamPlayStop();
                                }
                            }
                        });
                    }
                };

                this.Global.Zego.onDisconnect = function (err) {
                    that.$message.info("房间连接已断开,请检查网络后重新进入！");
                    that.Global.Zego.logout();
                    that.history.go(-1);
                };

                this.Global.Zego.onPlayStateUpdate = function (type, streamid, error) {
                    if (streamid.indexOf('us_') !== -1) {
                        that.isUsStreamPlay = (type === 0);
                    } else if (streamid.indexOf('opera_') !== -1) {
                        that.isOperaStreamPlay = (type === 0);
                    }
                };

                this.Global.Zego.onRecvRoomMsg = function (chat_data, server_msg_id, ret_msg_id) {
                    for (let i = 0; i < chat_data.length; i++) {
                        let item = chat_data[i];
                        that.insertTimeMessage();
                        that.roomMessages.push(item);
                    }
                    if (chat_data.length > 0) {
                        that.scrollChat2Bottom();
                    }
                };

                /*
                * 设置setUserStateUpdate后，SDK会自动拉取房间所有成员一次，之后通过onUserStateUpdate更新成员变化
                * */
                this.Global.Zego.onGetTotalUserList = function (roomId, userList) {
                    if (roomId !== that.Global.roomId) { return; }
                    that.userList.length = 0;
                    for (let i = 0; i < userList.length; i++) {
                        let user = userList[i];
                        that.userList.push({
                            userId: user.idName,
                            userName: user.nickName
                        });
                    }
                };

                this.Global.Zego.onUserStateUpdate = function (roomId, userList) {
                    if (roomId !== that.Global.roomId) { return; }
                    for (let i = 0; i < userList.length; i++) {
                        let userState = userList[i];
                        let name = userState.nickName.replace("us_", "超声端_").replace("admin_", "管理员_").replace("opera_", "手法端_");

                        let isExist = that.userInUserList(userState.idName);
                        if (userState.action === 1 && !isExist) { // 进入房间

                            that.userList.push({
                                userId: userState.idName,
                                userName: userState.nickName
                            });

                            let msgContent = name + " 进入房间";
                            that.sendSystemMessage(msgContent, true);

                        } else if (userState.action === 2 && isExist) { // 退出房间
                            that.userList.splice(that.userList.findIndex(item => {
                                return item.userId === userState.idName;
                            }), 1);

                            let msgContent = name + " 离开房间";
                            that.sendSystemMessage(msgContent, true);
                        }
                    }
                };
            },
        },
    }

</script>